import { DOCUMENT, inject, Injectable } from '@angular/core';
import { Meta, Title } from '@angular/platform-browser';

@Injectable({
  providedIn: 'root',
})
export class MetaService {
  private meta = inject(Meta);
  private title = inject(Title);
  private document = inject<Document>(DOCUMENT);

  public setDescription(desc: string) {
    this.meta.updateTag({ name: 'description', content: desc });
  }

  public setTitle(title: string) {
    this.title.setTitle(title);
  }

  public setRobotsNoIndex(hide: boolean) {
    this.meta.removeTag('name=robots');

    if (hide) {
      this.meta.addTag({ name: 'robots', content: 'noindex, nofollow' });
    }
  }
}
